<template>
  <card class="card-stats" :show-footer-line="true">
    <div class="row">
      <div class="col-4">
        <img class="card-image" :src="icon" />
      </div>
      <div class="col-8" v-if="$slots.content || title || subTitle">
        <div class="numbers" v-if="customClass != ''">
          <p
            v-html="subTitle"
            class="card-category"
            style="display: inline"
          ></p>
          &nbsp;
          <el-tooltip
            class="item"
            effect="dark"
            :content="message"
            placement="bottom"
          >
            <button
              class="btn-icon btn-round btn-link"
              style=" display: inline; all: unset;"
            > 
              <i
                :class="customClass"
                aria-hidden="true"
                style="font-size: 16px; color: #ffffff;" 
              ></i>
            </button>
          </el-tooltip>
          <h4 v-html="title" class="card-title"></h4>
        </div>
        <div class="numbers" v-else>
          <p v-html="subTitle" class="card-category"></p>
          <h4 v-html="title" class="card-title"></h4>
        </div>
      </div>
      <!-- <div
        class="col-lg text-right"
        
        style="position: absolute; bottom: 5%"
      ></div> -->
      <div class="stats" slot="footer" v-if="$slots.footer">
        <slot name="footer"></slot>
      </div>
    </div>
    <!-- <div class="row" >
      
    </div> -->
  </card>
</template>
<script>
import Card from "./Card.vue";

import { Tooltip } from "element-ui";

export default {
  name: "stats-card",
  components: {
    Card,
    [Tooltip.name]: Tooltip,
  },
  props: {
    icon: String,
    title: String,
    subTitle: String,
    customClass: String,
    message: String,
  },
  methods: {
    handleClick(evt) {
      this.$emit("click", evt);
    },
  },
};
</script>
<style scoped>
.col-4 {
  padding-left: 9%;
  padding-right: 0%;
}
.col-8 {
  padding-left: 5%;
}
.card-image {
  width: 60px;
}
</style>
